import { SelectOptionType } from '@/components/element/Form/SelectOptionType';
import { useEffect, useState } from 'react';
import Select, { MultiValue } from 'react-select';

type MultiSelectProps = {
  options?: SelectOptionType[];
  selectedIds?: number[];
  onChange: (d: MultiValue<SelectOptionType>) => void;
  error?: boolean;
  placeholder?: string;
  classes?: string;
};

export const SelectMulti = ({ options, selectedIds, onChange, error, placeholder, classes }: MultiSelectProps) => {
  const [values, setValues] = useState<SelectOptionType[]>([]);

  const _onChange = (d: MultiValue<SelectOptionType>) => {
    setValues(d.map((_d) => _d));
    onChange(d);
  };

  useEffect(() => {
    if (options && selectedIds) {
      setValues(options.filter((option) => selectedIds.includes(option.value)));
    }
  }, [options, selectedIds]);

  return (
    <Select
      className={classes}
      classNamePrefix="react-select"
      placeholder={placeholder ? placeholder : '選択して下さい'}
      theme={(theme) => ({
        ...theme,
        borderRadius: 3,
        colors: {
          ...theme.colors,
          primary25: '#e9aede',
          primary: '#e9aede',
        },
      })}
      classNames={{
        control: (state) => (state.isFocused ? 'focused' : ''),
      }}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderRadius: '0.5rem',
          borderColor: 'rgba(0, 0, 0, 0.125)',
          borderTopRightRadius: '0.5rem !important',
          borderBottomRightRadius: '0.5rem !important',
          borderLeftWidth: 1,
          padding: 1,
          fontSize: '0.875rem',
          fontWeight: 400,
          lineHeight: '1.4rem',
          border: error ? '1px solid #fd5c70' : '1px solid #d2d6da',
          transition: 'box-shadow 0.15s ease, border-color 0.15s ease',
          boxShadow: error ? '0 0 0 0px rgba(253, 92, 112, 0.6)' : state.isFocused ? '0 0 0 2px #e9aede' : '',
          '&:hover': {
            borderColor: '1',
          },
        }),
      }}
      isMulti={true}
      options={options}
      onChange={_onChange}
      value={values}
    />
  );
};
